import React, { useEffect, useState } from 'react';
import { BoxWrapper } from '../../../style';
import { useNavigate } from 'react-router-dom';
import { getStorage, setStorage } from '../../../Utils/common';
import { getDashboardData } from '../../../Utils/api';


function ThankYou() {
  const navigate = useNavigate();
  const [progressBar, setProgressBar] = useState(getStorage('percent'));
  const [leadId, setLeadId] = useState("");

  useEffect(() => {
    // Get lead_id from localStorage first
    const storedLeadId = getStorage("lead_id");
    if (storedLeadId) {
      setLeadId(storedLeadId);
    } else {
      // If not in localStorage, fetch from backend
      const fetchLeadId = async () => {
        try {
          const params = { profile_id: getStorage("cust_profile_id") || "" };
          const response = await getDashboardData(params);
          
          if (response?.data?.Status === 1) {
            const backendLeadId = response?.data?.Data?.profile_details?.lead_id;
            if (backendLeadId) {
              setLeadId(backendLeadId);
              setStorage("lead_id", backendLeadId);
            }
          }
        } catch (error) {
          console.log("Error fetching lead ID:", error);
        }
      };
      
      fetchLeadId();
    }
  }, []);

  return (
    <div>
      <BoxWrapper className="w100">
        <div className="formmainBox flex">
          <div className="left"></div>
          <div className="right">
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
              {/* Success Icon */}
              <div style={{ 
                fontSize: '80px', 
                color: '#28a745', 
                marginBottom: '20px' 
              }}>
                ✅
              </div>
              <br/>
              {/* Main Heading */}
              <h1 style={{ 
                color: '#28a745', 
                fontSize: '28px', 
                marginBottom: '15px',
                fontWeight: '600'
              }}>
                Congratulations!
              </h1>
              
              {/* Lead ID Display */}
              {leadId && (
                <div style={{ 
                  backgroundColor: '#f8f9fa', 
                  border: '2px solid #28a745',
                  borderRadius: '10px',
                  padding: '20px',
                  margin: '20px 0',
                  display: 'inline-block'
                }}>
                  <h3 style={{ 
                    color: '#333', 
                    fontSize: '18px', 
                    margin: '0 0 10px 0',
                    fontWeight: '500'
                  }}>
                    Your Lead ID
                  </h3>
                  <div style={{ 
                    fontSize: '24px', 
                    fontWeight: 'bold', 
                    color: '#28a745',
                    letterSpacing: '2px'
                  }}>
                    {leadId}
                  </div>
                </div>
              )}
              
              {/* Message */}
              <div style={{ 
                backgroundColor: '#e7f3ff', 
                border: '1px solid #b3d9ff',
                borderRadius: '10px',
                padding: '25px',
                margin: '20px 0',
                maxWidth: '600px',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}>
                <p style={{ 
                  fontSize: '18px', 
                  color: '#333', 
                  margin: '0 0 15px 0',
                  lineHeight: '1.6'
                }}>
                  🎉 <strong>Congratulations!</strong> Your application has been submitted successfully!
                </p>
                <p style={{ 
                  fontSize: '16px', 
                  color: '#666', 
                  margin: '0 0 15px 0',
                  lineHeight: '1.5'
                }}>
                  Our teammate will contact you soon for further processing and verification.
                </p>
                <p style={{ 
                  fontSize: '14px', 
                  color: '#888', 
                  margin: '0',
                  fontStyle: 'italic'
                }}>
                  Please keep your Application ID handy for future reference.
                </p>
              </div>
              
              {/* Action Button */}
              <div style={{ marginTop: '30px' }}>
                <button
                  onClick={() => navigate('/my-dashboard/')}
                  style={{
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    padding: '12px 25px',
                    borderRadius: '6px',
                    fontSize: '16px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                >
                  Continue to Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      </BoxWrapper>
    </div>
  );
}

export default ThankYou;
